import React, { useContext } from 'react'
import { PuckConfigContext } from 'puck/PuckConfigContext'
import { ResponsiveRender } from 'puck/responsive'
import { readPuckDataVersion } from 'puck/editor/parse'

const PuckStep = ({
  step,
  brk,
  onEngage = () => {},
  onAwardPoints = () => {},
  onChangeBackground = () => {},
  onStepSkip = () => {},
  skipButton,
  nextStepButton,
  puckConfig: puckConfigProp,
}) => {
  const contextConfig = useContext(PuckConfigContext)
  const puckConfig = puckConfigProp ?? contextConfig

  let puckData = null
  try {
    // After beaker2 enrichment the full puck object lands on step.puck;
    // direct saves (editor preview) use step.content (JSON string).
    const raw = step.puck ?? step.content
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
    if (parsed?.content && Array.isArray(parsed.content)) {
      puckData = parsed
    } else if (Array.isArray(step.promo_page?.content)) {
      // PROMO_PAGE steps: beaker2-utils enriches by storing GET /step/:id
      // response as step.promo_page (step[type.toLowerCase()]). When the
      // author has saved puck content via the editor, that response IS the
      // puck data object.
      puckData = step.promo_page
    }
  } catch (e) {
    console.error('[PuckStep] Failed to parse puck data', e)
  }

  if (!puckData || !puckConfig) return null

  // Saved-data version (BR-5406). '0.0.0' = pre-versioning saves. No
  // branching yet — exposed via metadata for future migrations.
  const puckDataVersion = readPuckDataVersion(puckData)

  return (
    <ResponsiveRender
      config={puckConfig}
      data={puckData}
      metadata={{
        puckDataVersion,
        brk,
        step,
        onEngage,
        onAwardPoints,
        onChangeBackground,
        onStepSkip,
        skipButton,
        nextStepButton,
      }}
    />
  )
}

export default PuckStep
